import React from 'react';
import CenterSpinner from '../../../../general/Loadings/CenterSpinner';
import PropTypes from 'prop-types';

const CreateNewRule = React.lazy(() => import('./CreateNewRule'));
const EditRule = React.lazy(() => import('./EditRule'));

const CustomDataLayerRule = ({ id }) => {
     return (
          <div className='rule-detail'>
               <React.Suspense fallback={<CenterSpinner />}>{id ? <EditRule id={id} /> : <CreateNewRule />}</React.Suspense>
          </div>
     );
};


CustomDataLayerRule.propTypes = {
     id: PropTypes.string,
};

export default CustomDataLayerRule;
